

/// <reference path="CoreEntityUpdatedBy.ts" />

// Generated class DocumentLink_ManagedObject

class DocumentLink_ManagedObject extends CoreEntityUpdatedBy
{

    // Property: concept
    set concept(value:string) {
        this.setValueForKey(value, 'concept');
    }
    get concept():string {
        return this.valueForKey('concept');
    }
    set conceptPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'concept');
    }
    get conceptPrimitiveValue():string {
        return this.primitiveValueForKey('concept');
    }

    // Property: linkedEntityID
    set linkedEntityID(value:string) {
        this.setValueForKey(value, 'linkedEntityID');
    }
    get linkedEntityID():string {
        return this.valueForKey('linkedEntityID');
    }
    set linkedEntityIDPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'linkedEntityID');
    }
    get linkedEntityIDPrimitiveValue():string {
        return this.primitiveValueForKey('linkedEntityID');
    }

    // Property: linkedEntityName
    set linkedEntityName(value:string) {
        this.setValueForKey(value, 'linkedEntityName');
    }
    get linkedEntityName():string {
        return this.valueForKey('linkedEntityName');
    }
    set linkedEntityNamePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'linkedEntityName');
    }
    get linkedEntityNamePrimitiveValue():string {
        return this.primitiveValueForKey('linkedEntityName');
    }
}
